import { parse } from 'query-string';
import {
  CASE_METRICS_TOGGLES,
  SUPER_SELECT_ALL_PREFIX,
  jobNames
} from './../helpers';
import {
  LOCATION_CHANGE,
  SELECT_JOB,
  SET_ARTIFACTS_INFO,
} from './../actions';

const initialState = {
  artifactsMetricsInfo: {
    toggles: 15,
    buildFilter: '',
    nodes: ['all'],
    image: '',
    givenJob: '',
    dispatcherId: 0,
    jobName: jobNames.CASE_METRICS
  },
  artifactsInfo: {
    inGroups: true,
    groups: [],
    hunters: []
  },
  selectedJobs: []
};

const artifactsMetricsPage = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_JOB:
      if (action.value === undefined) return { ...state };

      const actionAsSelectedJob = {
        value: `${action.value}`,
        index: action.index,
        jobId: action.jobId
      };

      const initSelected = state.selectedJobs.length === 1 ?
        state.selectedJobs[0] && state.selectedJobs[0].value !== action.value ?
          state.selectedJobs :
          [] :
        [];

      return {
        ...state,
        selectedJobs: [...initSelected, actionAsSelectedJob]
      };
    case SET_ARTIFACTS_INFO:
      return {
        ...state,
        artifactsInfo: {
          inGroups: action.info.inGroups,
          groups: action.info.groups,
          hunters: action.info.hunters
        }
      };
    case LOCATION_CHANGE:
      if (!action.payload ||
        !action.payload.search || action.payload.pathname !== '/artifacts-metrics') {
        return state;
      }

      // These are for the main selector:
      // t: build type bit representation
      // f: build filter
      // n: nodes
      // i: selected image name
      // j: given job number, used to highlight a job coming from another page
      // d: id for selected dispatcher
      // These are for the artifacts selector:
      // g: artifact hunter group
      // The names need to be short because they're part of the URL query.
      const { f, n, i, t, j, d } = parse(action.payload.search);

      const parseArtifactsMetricsInfo = (
        toggles,
        buildFilter,
        nodes,
        image,
        givenJob,
        dispatcher,
        metricInfo,
      ) => {
        const parsedToggles = parseInt(toggles);
        const parsedGivenJob = parseInt(j);
        const parsedDispatcher = parseInt(dispatcher);

        return {
          toggles: (parsedToggles < 0) || (parsedToggles > 15) || isNaN(parsedToggles) ?
            metricInfo.toggles :
            parsedToggles,
          buildFilter: buildFilter ? buildFilter : '',
          nodes: nodes ?
            Array.isArray(nodes) ? nodes : [nodes] :
            [],
          image: image ? image : '',
          givenJob: (parsedGivenJob < 0) || isNaN(parsedGivenJob) ?
            metricInfo.givenJob :
            parsedGivenJob,
          dispatcherId: (parsedDispatcher < 0) || isNaN(parsedDispatcher) ?
            0 :
            parsedDispatcher,
          jobName: metricInfo.jobName
        };
      };

      const parsedInfo =
        parseArtifactsMetricsInfo(t, f, n, i, j, d, state.artifactsMetricsInfo);
      return {
        ...state,
        artifactsMetricsInfo: parsedInfo,
        selectedJobs: parsedInfo.givenJob ?
          [{ value: `${parsedInfo.givenJob}` }] :
          []
      };

    default:
      return state;
  }
};

export default artifactsMetricsPage;

const getArtifactsMetricsPage = state => state.artifactsMetricsPage;
export const getArtifactsMetricsInfo = state =>
  getArtifactsMetricsPage(state).artifactsMetricsInfo ||
  initialState.artifactsMetricsInfo;
export const getArtifactsInfo = state =>
  getArtifactsMetricsPage(state).artifactsInfo || initialState.artifactsInfo;
export const getArtifactsGroups = state =>
  getArtifactsInfo(state).groups.filter(h => !h.startsWith(SUPER_SELECT_ALL_PREFIX));
export const getArtifactHunters = state =>
  getArtifactsInfo(state).hunters.filter(h => !h.startsWith(SUPER_SELECT_ALL_PREFIX));
export const getArtifactsMetricsOutliersShown = state =>
  getArtifactsMetricsInfo(state).toggles & CASE_METRICS_TOGGLES.OUTLIER;
export const getArtifactsSelectedJobs = state =>
  getArtifactsMetricsPage(state).selectedJobs;


// WEBPACK FOOTER //
// src/reducers/artifactsMetricsPage.js